import { render } from "./AW23TextCard.vue?vue&type=template&id=06cc021e&scoped=true"
import script from "./AW23TextCard.vue?vue&type=script&lang=js"
export * from "./AW23TextCard.vue?vue&type=script&lang=js"

import "./AW23TextCard.vue?vue&type=style&index=0&id=06cc021e&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cc021e"]])

export default __exports__